(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('HandbookVersionStateHistory', HandbookVersionStateHistory);

    HandbookVersionStateHistory.$inject = ['$resource', 'DateUtils'];

    function HandbookVersionStateHistory ($resource, DateUtils) {
        var resourceUrl =  'api/handbook-version-state-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.stateSetTimestamp = DateUtils.convertDateTimeFromServer(data.stateSetTimestamp);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
